module.exports = __webpack_public_path__ + "static/media/promptpay_desktop.98a7c6db.png";